import { useNavigate } from 'react-router-dom';

import { previousTermList, resPreviousTermListProps, termsTypeProps } from '@/api/server/terms/read';
import { Fragment, useEffect, useState } from 'react';
import SFMenu from '@/component/my/sf-menu';
import Divider from '@mui/material/Divider';
import ErrorRes from '@/api/server/ErrorRes';
// import ErrorRes from '@/api/server/ErrorRes123';

export type termsPrivousProps = {
  type: termsTypeProps;
};
export default function TermsPrivous({ type }: termsPrivousProps) {
  const navigate = useNavigate();
  const [list, setList] = useState<resPreviousTermListProps[]>([]);
  useEffect(() => {
    (async () => {
      const lang = 'KO' as const;
      const payload = {
        lang,
        terms_type: type,
      };
      const re = await previousTermList(payload);
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      } else {
        setList(re.data.list);
      }
    })();

    return () => {};
  }, [type]);

  return (
    <>
      {list.length > 0
        ? list.map((item: any) => (
            <Fragment key={item.terms_id}>
              <SFMenu.ArrowRightItem
                text={`${item.terms_ver} | ${item.reg_dt}`}
                onClick={() => {
                  navigate(`/terms/${item.terms_id}/${item.terms_type}`);
                }}
              />
              <Divider sx={{ my: 2 }} />
            </Fragment>
          ))
        : ''}
    </>
  );
}
